var _path, _rect;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStrikethrough(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 22,
    viewBox: "0 0 21 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.2805 6.42256H13.3465V12.2511C13.3465 12.8529 13.2046 13.3902 12.9209 13.863C12.6401 14.333 12.2432 14.7041 11.7303 14.9763C11.2174 15.2456 10.6156 15.3803 9.92498 15.3803C9.23438 15.3803 8.63261 15.2456 8.11967 14.9763C7.60674 14.7041 7.20842 14.333 6.92473 13.863C6.6439 13.3902 6.50349 12.8529 6.50349 12.2511V6.42256H7.56948V12.1652C7.56948 12.595 7.66405 12.9775 7.85318 13.3128C8.0423 13.6452 8.31167 13.9074 8.66127 14.0994C9.01373 14.2885 9.43497 14.3831 9.92498 14.3831C10.415 14.3831 10.8362 14.2885 11.1887 14.0994C11.5412 13.9074 11.8105 13.6452 11.9968 13.3128C12.1859 12.9775 12.2805 12.595 12.2805 12.1652V6.42256Z",
    fill: "#38cb89"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 5.0625,
    y: 10.6318,
    width: 9.51042,
    height: 0.864583,
    fill: "#38cb89"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStrikethrough);
export default __webpack_public_path__ + "static/media/strikethrough.d5c5e5e7e4fca670d19461696ac0e599.svg";
export { ForwardRef as ReactComponent };